const Slider = (({ jQuery: $ }) => {
    class Slider {
        constructor(node) {
            this.$node = $(node);
            this.slideDuration = 4000;
            this.timeout = null;
            this.$slides = this.$node.find('[data-js="slide"]');
            this.slidesCount = this.$slides.length;
            this.$navItems = this.$node
                .find('[data-js="slider-dots"]')
                .children();
            this.activeClassLabel = 'js-is-active';
        }

        next(index = null) {
            let positions = this.getNextIndex();

            index = index !== null ? index : positions.active;

            let next = positions.up_next;

            $.each([this.$slides, this.$navItems], (i, $elems) => {
                $elems.removeClass(this.activeClassLabel);
                $elems.removeClass('up-next');

                $elems.eq(index).addClass(this.activeClassLabel);

                $elems.eq(next).addClass('up-next');
            });

            this.resetTimeout();
        }

        onNavItemClick(e) {
            this.clearTimeout();
            const index = $(e.currentTarget).index();

            this.next(index);
        }

        getNextIndex() {
            const curIndex = this.$slides
                .filter(`.${this.activeClassLabel}`)
                .index();

            let active = curIndex + 1 < this.slidesCount ? curIndex + 1 : 0;
            let exiting = curIndex;

            let positions = {
                active: active,
                up_next: active + 1 < this.slidesCount ? active + 1 : 0,
                exiting: exiting,
            };

            return positions;
        }

        setUpNext() {
            let index = this.getNextIndex().active;
            this.$slides.eq(index).addClass('up-next');
        }

        exitActiveSlide() {
            let index = this.getNextIndex().exiting;

            let durationBeforeExit = this.slideDuration - 250;

            setTimeout(() => {
                this.$slides.eq(index).addClass('exiting');
            }, durationBeforeExit);
        }

        clearTimeout() {
            clearTimeout(this.timeout);

            return this;
        }

        removeAnimation() {
            $('.exiting').removeClass('exiting');
        }

        setAnimaionEvents() {
            $('.js-is-active').on(
                'transitionend',
                this.removeAnimation.bind(this)
            );
        }

        resetTimeout(duration = this.slideDuration) {
            this.clearTimeout();

            this.timeout = setTimeout(this.next.bind(this), duration);

            this.exitActiveSlide.call(this);
            this.setAnimaionEvents();
            return this;
        }

        init() {
            if (!this.$slides.length > 1) return;
            this.setUpNext();
            this.resetTimeout();
        }
    }

    return {
        init({ selector }) {
            return new Slider(selector).init();
        },
    };
})(window);

export default Object.create(Slider);
